var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"outlined":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Weekly Specials")]),_c('v-spacer'),_c('CreateBtn')],1),_c('Table')],1),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }